// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["label", "description", "tooltipProps", "checked", "onChange", "disabled", "size"];
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { cn } from "../../common/utils";
import { Base } from "../Typography/Base";
import { Icon } from "../Icon";
import { Tooltip } from "../Tooltip/Tooltip";
export var ToggleSize = /*#__PURE__*/function (ToggleSize) {
  ToggleSize["DEFAULT"] = "default";
  ToggleSize["LARGE"] = "lg";
  return ToggleSize;
}({});
var getSizeClassName = function getSizeClassName(size) {
  switch (size) {
    case ToggleSize.DEFAULT:
      return {
        root: 'cop-h-4 cop-w-8',
        dot: 'cop-h-3 cop-w-3'
      };
    case ToggleSize.LARGE:
    default:
      return {
        root: 'cop-h-5 cop-w-10',
        dot: 'cop-h-4 cop-w-4'
      };
  }
};
export var Toggle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var label = props.label,
    description = props.description,
    tooltipProps = props.tooltipProps,
    checked = props.checked,
    onChange = props.onChange,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$size = props.size,
    size = _props$size === void 0 ? ToggleSize.DEFAULT : _props$size,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "cop-flex cop-gap-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "cop-cursor-pointer"
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: "cop-peer cop-sr-only cop-fixed",
    ref: ref,
    type: "checkbox",
    checked: checked,
    onChange: onChange,
    disabled: disabled
  }, rest)), /*#__PURE__*/React.createElement("div", {
    className: cn('cop-group cop-relative cop-rounded-full cop-outline-none peer-focus-visible:cop-outline-2 peer-focus-visible:cop-outline-[#0071E3]', _defineProperty({}, 'cop-pointer-events-none', disabled))
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('cop-block cop-rounded-full cop-bg-input-gray group-hover:cop-bg-gray-300 ', getSizeClassName(size).root, _defineProperty(_defineProperty({}, '!cop-bg-[#212B36] group-hover:!cop-bg-[#36424D]', checked), '!cop-opacity-25', disabled))
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('cop-absolute cop-top-[2px] cop-rounded-full cop-bg-white cop-transition', getSizeClassName(size).dot, _defineProperty(_defineProperty(_defineProperty({}, 'cop-left-[2px]', !checked), 'cop-right-[2px]', checked), 'cop-bg-[#DFE1E4]', disabled))
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "cop-flex cop-gap-1"
  }, /*#__PURE__*/React.createElement(Base, {
    variant: "body",
    size: "base",
    leading: "tight",
    tag: "span",
    weight: "medium"
  }, label), tooltipProps && /*#__PURE__*/React.createElement(Tooltip, tooltipProps, /*#__PURE__*/React.createElement(Icon, {
    icon: "Info",
    className: "cop-h-3 cop-w-3 cop-text-primary"
  }))), description && /*#__PURE__*/React.createElement("div", {
    className: "cop-mt-0.5 cop-text-secondary"
  }, /*#__PURE__*/React.createElement(Base, {
    variant: "body",
    size: "sm",
    leading: "normal",
    tag: "span",
    weight: "regular"
  }, description)))));
});
Toggle.displayName = 'Toggle';
